import { useRef, useState } from "react";

import { SubjectAskPanel, SubjectAskTrigger } from "./SubjectAskPanel.js";

/** Ask Insights beside a map, pinned to that map. */
export function MapAskChrome({ mapId }: { mapId: string }) {
  const triggerRef = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState(false);
  const [mounted, setMounted] = useState(false);
  const source = { type: "ideation_map" as const, id: mapId };

  return (
    <>
      <SubjectAskTrigger
        source={source}
        open={open}
        triggerRef={triggerRef}
        onOpen={() => {
          setMounted(true);
          setOpen(true);
        }}
      />
      <SubjectAskPanel
        source={source}
        open={open}
        mounted={mounted}
        onClose={() => setOpen(false)}
      />
    </>
  );
}
